import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '@gan/core/util-environment';

import {
  BusReplacementInterface,
  BusReplacementService as BaseBusReplacementService,
} from '@gan/common/data-bus-replacements';
import { MethodTypeEnum, useNotification } from '@gan/common/ui-notification';

/**
 * replacement service
 */
@Injectable()
export class BusReplacementService extends BaseBusReplacementService {
  protected override http = inject(HttpClient);

  /**
   * get replacements timetable details
   * @param trainServiceId - train service id
   */
  override getReplacementTimeTableDetails(trainServiceId: string): Observable<BusReplacementInterface[]> {
    return this.http
      .get<BusReplacementInterface[]>(`${environment.STAFF_URL}/train-card/${trainServiceId}/replacements`)
      .pipe(useNotification({ method: MethodTypeEnum.GET, resourceName: 'Replacements Timetable Details' }));
  }
}
